import { render, staticRenderFns } from "./CompanyInWeb.vue?vue&type=template&id=c8558156&scoped=true&"
import script from "./CompanyInWeb.vue?vue&type=script&lang=js&"
export * from "./CompanyInWeb.vue?vue&type=script&lang=js&"
import style0 from "./CompanyInWeb.vue?vue&type=style&index=0&id=c8558156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8558156",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
